"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_ClaimResponse_SubDetail = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_positiveInt_1 = require("../Scalar/RTTI_positiveInt");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_ClaimResponse_Adjudication_1 = require("./RTTI_ClaimResponse_Adjudication");
exports.RTTI_ClaimResponse_SubDetail = t.recursion('IClaimResponse_SubDetail', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        subDetailSequence: RTTI_positiveInt_1.RTTI_positiveInt,
        _subDetailSequence: RTTI_Element_1.RTTI_Element,
        noteNumber: t.array(RTTI_positiveInt_1.RTTI_positiveInt),
        _noteNumber: t.array(RTTI_Element_1.RTTI_Element),
        adjudication: t.array(RTTI_ClaimResponse_Adjudication_1.RTTI_ClaimResponse_Adjudication)
    });
});
//# sourceMappingURL=RTTI_ClaimResponse_SubDetail.js.map